import { stats } from "@/mocks/site";

export default function StatsBand() {
  return (
    <section className="bg-primary-950 text-background-50">
      <div className="max-w-editorial mx-auto px-4 md:px-8 py-12 md:py-16">
        <p className="text-xs tracking-[0.25em] text-accent-400 uppercase">档案样本观察</p>
        <h2 className="mt-3 font-heading text-xl md:text-2xl font-bold text-background-50 max-w-3xl">
          在被「挂出来」之后，当事人究竟经历了什么
        </h2>

        <dl className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((item) => (
            <div key={item.value} className="border-t border-background-100/15 pt-6">
              <dt className="sr-only">{item.label}</dt>
              <dd>
                <span className="block font-heading text-3xl md:text-4xl font-black text-accent-400">
                  {item.value}
                </span>
                <span className="mt-3 block text-sm leading-relaxed text-background-200/80">
                  {item.label}
                </span>
              </dd>
            </div>
          ))}
        </dl>

        <p className="mt-8 text-xs text-background-300/60">
          数据来自回声墙自 2023 年以来收录并获授权的亲述档案统计，仅用于呈现当事人在求助前后的普遍状态。
        </p>
      </div>
    </section>
  );
}